import script from "./deliOnceImg3.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg3.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg3.vue?vue&type=style&index=0&id=1b6da192&lang=less"

const __exports__ = script;

export default __exports__